import ApiConfig from '../config/api'
import BaseAction from './action.abstract'

export default class InstanceAction extends BaseAction {
  fetchInstanceList(condition?: any): Promise<any> {
    return this.FetchSimpleList(ApiConfig.api.machine.instance_list, condition)
  }

  fetchInstanceInfo(instanceId: any): Promise<any> {
    return this.FetchSimpleData(ApiConfig.api.machine.instance_info, {
      instance_id: instanceId,
    })
  }
}

export const instanceAction = new InstanceAction()
